import { useV2UpdateReleaseFlagMutation } from "@generated";
import { ReleaseFlagFormValues } from "../../types";

const useUpdateReleaseFlag = () => {
  const [updateReleaseFlag, state] = useV2UpdateReleaseFlagMutation();

  const submit = (id: number, values: ReleaseFlagFormValues) =>
    updateReleaseFlag({
      id,
      body: {
        data: {
          id,
          type: "release-flags",
          attributes: {
            name: values.name,
            key: values.key,
            description: values.description,
            status: values.status,
            "beta-release-date": values.betaReleaseDate,
            "general-availability-date": values.generalAvailabilityDate,
          },
        },
      },
    }).unwrap();

  return { submit, isLoading: state.isLoading };
};

export default useUpdateReleaseFlag;
